<template>
  <ScenePreviewCached
    :scene-id="sceneId"
    :display="display"
    :max-width="previewMaxWidth"
    :max-height="previewMaxHeight"
    :is-active-scene="isActiveScene"
    :eager="eager"
  />
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useScenesStore } from '@/stores/scenes'
import ScenePreviewCached from './ScenePreviewCached.vue'
import type { Display } from '@/stores/displays'

interface Props {
  sceneId: string
  display: Display
  previewMaxWidth?: number
  previewMaxHeight?: number
  /** Skip lazy loading - for VueFlow nodes that are already visible when mounted */
  eager?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  eager: false
})

const scenesStore = useScenesStore()

// Check if this scene is the active scene
const isActiveScene = computed(() => {
  const activeScene = scenesStore.getActiveScene
  return activeScene?.id === props.sceneId
})
</script>